import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "BEFORE YOU GO...", -1)
const _hoisted_3 = { class: "cancel-flow__main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "cancel-flow__heading" }, "Are you sure you want to cancel?", -1)
const _hoisted_5 = {
  class: "cancel-flow__body",
  style: {"margin-bottom":"16px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "cancel-flow__value-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Wireless content sharing"),
    /*#__PURE__*/_createTextVNode(" that makes collaboration easy and cable-free")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Dynamic digital signage"),
    /*#__PURE__*/_createTextVNode(" that highlights what matters most")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "On-screen alerts"),
    /*#__PURE__*/_createTextVNode(" that keep people in your spaces safe and informed")
  ])
], -1)
const _hoisted_8 = { class: "cancel-flow__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(" Your screens will go dark on "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.periodEndLabel), 1),
          _createTextVNode("."),
          _hoisted_6,
          _createTextVNode(" Here's what you'll lose: ")
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('stay')))
      }, "I'll stay"),
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--danger",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
      }, "Continue cancellation")
    ])
  ]))
}